import Image from 'next/image'
import { Snippet } from '@nextui-org/snippet'
import { Button } from '@nextui-org/button'
import { Modal, ModalBody, ModalContent, ModalHeader, useDisclosure } from '@nextui-org/react'

import shareIcon from '@/assets/icons/share.svg'
import { useAppDispatch, useAppSelector } from '@/hooks'
import ICONS from '@/assets/icons'
import { base_url, handleCopy } from '@/utils'
import { settingsActions } from '@/redux/reducers/settings/setting.reducer'
import useIsMobile from '@/hooks/useIsMobile'

import styles from './styles.module.css'
const InviteCode = ({ isShowLabel = true }: { isShowLabel?: boolean }) => {
  const user = useAppSelector((state) => state.root.auth.user)
  const { isOpen, onOpen, onOpenChange } = useDisclosure()
  const isMobile = useIsMobile()
  const dispatch = useAppDispatch()
  return (
    <>
      <div className={styles.containerInviteCode}>
        {isShowLabel && <h2>Invite Code</h2>}

        <div className="flex gap-2">
          <div className="flex h-[44px] w-full items-center justify-between rounded-lg border border-white/10 bg-[#80819110] px-2 text-[12px] text-white">
            <Snippet
              hideSymbol
              classNames={{
                base: 'bg-transparent flex-1 px-1 text-white',
                pre: 'text-[14px] text-white',
                copyIcon: 'w-[20px] h-[20px] text-white',
                copyButton: 'text-white',
                content: '!text-white',
              }}
              tooltipProps={{
                color: 'default',
              }}
              size="md"
              radius="sm"
            >
              {user?.inviteCode}
            </Snippet>
            <Button
              onPress={() => {
                if (isMobile) {
                  dispatch(settingsActions.setMenu(false))
                }

                onOpen()
              }}
              variant="light"
              color="secondary"
              className="h-[32px] min-w-[28px] max-w-[32px] px-0 text-ss-grayscale-100 data-[hover=true]:bg-transparent"
            >
              {' '}
              <Image src={shareIcon.src} alt="" width={13} className="h-[20px] w-[32px]" height={13} />
            </Button>
          </div>
        </div>
      </div>
      <Modal size="2xl" hideCloseButton isOpen={isOpen} onOpenChange={onOpenChange} placement="center">
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex items-center gap-6 border-b border-white/10">
                <Image
                  onClick={onClose}
                  className="cursor-pointer"
                  src={ICONS.icCloseWhite}
                  width={22}
                  height={22}
                  alt=""
                />
                <h3 className="text-base font-medium text-white">Referral link</h3>
              </ModalHeader>
              <ModalBody className="py-4 text-white">
                <div className="flex items-center gap-2">
                  <div className="flex-1 rounded-xl border border-white/10 px-3.5 py-2.5 text-sm">{`${base_url}/sign-in?inviteCode=${user?.inviteCode}`}</div>

                  <Button
                    size="md"
                    className="bg-btn-gradient py-2.5 text-sm font-medium"
                    onClick={() => {
                      handleCopy(`/sign-in?inviteCode=${user?.inviteCode}`, 'link')
                      onClose()
                    }}
                  >
                    Copy
                  </Button>
                </div>
              </ModalBody>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  )
}

export default InviteCode
